import type { Me } from "@alm/api-contracts";
import {
  can,
  NAVIGATION,
  navItem,
  WORKSPACE_BY_ID,
  settingsSections,
  workspaceScreens,
  type PolicySubject,
} from "@alm/policy";
import { routeAllowed } from "@/lib/policy";

/** The first setting this login may open, in the order the rails list them. Somebody who may
 * change no setting (a cook, a caregiver) opens on their own profile, not a list they can only
 * read. */
export function firstSettingsPath(me: Me): string | null {
  const reachable = NAVIGATION.filter((entry) => routeAllowed(me, entry));
  const sections = settingsSections(workspaceScreens(WORKSPACE_BY_ID.settings, reachable));
  if (!changesSettings(me) && reachable.some((entry) => entry.id === "settings")) {
    return navItem("settings").path;
  }
  return sections[0]?.categories[0]?.items[0]?.path ?? null;
}

function changesSettings(me: Me): boolean {
  const subject = me.subject as PolicySubject;
  return (
    can(subject, "settings:manage") ||
    me.buildings.some((building) => can(subject, "settings:manage", { facilityId: building.id }))
  );
}
